window.onpageshow = function (e) {
    if (e.persisted) {
        document.querySelector('.c-fade').style.display = 'none';
        document.body.classList.add('is-show');
    }
};

window.addEventListener('load', function () {
    const fade = document.querySelector('.c-fade');
    const MIN_TIME = 400;
    const start = performance.now();

    function end() {
        fade.classList.add('is-hide');
        document.body.classList.add('is-show');
        setTimeout(() => {
            fade.style.display = 'none';
        }, 300);
    }

    const elapsed = performance.now() - start;
    if (elapsed < MIN_TIME) {
        setTimeout(end, MIN_TIME - elapsed);
    } else {
        end();
    }
});